import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ChevronUp } from 'lucide-react';
const faqs = [{
  question: '¿Necesito experiencia previa?',
  answer: 'No, el método está diseñado para llevarte desde cero absoluto hasta un nivel profesional. Explicamos cada técnica paso a paso.'
}, {
  question: '¿Cómo recibo el material?',
  answer: 'Inmediatamente después de tu compra recibís un correo con el acceso a nuestra plataforma digital donde podrás ver y descargar todo el contenido.'
}, {
  question: '¿Puedo verlo desde el celular?',
  answer: 'Sí, la plataforma es 100% compatible con celulares, tablets y computadoras. Podés estudiar desde donde quieras.'
}, {
  question: '¿El contenido es digital o físico?',
  answer: 'Es un producto 100% digital. No enviamos nada por correo postal, lo que te permite empezar hoy mismo sin costos de envío.'
}, {
  question: '¿Cuánto tiempo tengo acceso?',
  answer: 'El acceso es de por vida. Pagás una única vez y podés ver el contenido las veces que quieras, para siempre.'
}, {
  question: '¿Qué métodos de pago aceptan?',
  answer: 'Aceptamos todas las tarjetas de crédito y débito, y Mercado Pago para tu mayor seguridad y comodidad.'
}, {
  question: '¿Qué hago si tengo otra duda?',
  answer: 'Estamos para ayudarte. Podés escribirnos en cualquier momento a Pixastores@gmail.com y te responderemos a la brevedad.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <div className="max-w-3xl mx-auto mt-20 mb-12" data-id="element-20">
      <h2 className="text-3xl font-bold text-center text-gray-900 mb-10" data-id="element-21">
        Preguntas Frecuentes
      </h2>
      <div className="space-y-4" data-id="element-22">
        {faqs.map((faq, index) => <div key={index} className="border border-purple-100 rounded-xl bg-white overflow-hidden shadow-sm" data-id="element-23">
            <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 text-left bg-white hover:bg-purple-50 transition-colors" data-id="element-24">
              <span className="font-bold text-gray-800" data-id="element-25">{faq.question}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-purple-600" data-id="element-26" /> : <ChevronDown className="w-5 h-5 text-gray-400" data-id="element-27" />}
            </button>
            <AnimatePresence data-id="element-28">
              {openIndex === index && <motion.div initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: 'auto',
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.3
          }} data-id="element-29">
                  <div className="p-5 pt-0 text-gray-600 border-t border-purple-50" data-id="element-30">
                    {faq.answer}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>)}
      </div>
      <div className="text-center mt-10 p-6 bg-purple-50 rounded-xl border border-purple-100" data-id="element-31">
        <p className="text-gray-700 font-medium" data-id="element-32">
          📩 ¿Tenés otra duda? Escribinos a:{' '}
          <a href="mailto:Pixastores@gmail.com" className="text-purple-600 font-bold hover:underline" data-id="element-33">
            Pixastores@gmail.com
          </a>
        </p>
      </div>
    </div>;
}